/* eslint-disable no-param-reassign */

const initialState = () => ({
  flagsState: {},
  flags: {},
});

export { initialState as state };

export const mutations = {
  receiveFlagsState(state, data) {
    state.flagsState = data;
  },

  receiveFlags(state, data) {
    state.flags = data;
  },
};

export const actions = {};
